import { EXTERNAL_PLATFORM_ALLOWED_TEMPLATE_TYPES } from '../constants/allowedTemplateTypes';
import type { ExternalPlatformMode } from '../hooks/useExternalPlatform';

/**
 * 퀴즈 한 건이 현재 외부 플랫폼 모드에서 노출 가능한지.
 *
 * 퀴즈와 모음이 섞인 목록에서는 배열 단위 필터를 쓸 수 없어(모음까지 걸러진다) 단건이 필요하다.
 */
export function isExternalPlatformQuizAllowed<
  T extends { templateType?: string | null },
>(quiz: T, mode: ExternalPlatformMode): boolean {
  if (mode === 'none') return true;
  const allowed = EXTERNAL_PLATFORM_ALLOWED_TEMPLATE_TYPES as readonly string[];
  return !quiz.templateType || allowed.includes(quiz.templateType);
}

export function filterExternalPlatformQuizzes<
  T extends { templateType?: string | null },
>(quizzes: T[], mode: ExternalPlatformMode): T[] {
  if (mode === 'none') return quizzes;
  return quizzes.filter(quiz => isExternalPlatformQuizAllowed(quiz, mode));
}
